export default __webpack_public_path__ + "static/media/AKM_6.41bf22a4.png";